module.exports = "/images/smallHome.png?ea121f07a39bb7b9e2ae2774fbffc7b9";